import React from "react";
import { XIcon } from "lucide-react";
import { painPoints } from "../data/salesContent";
export function PainPoints() {
  return <section aria-labelledby="dolor" className="w-full bg-ink py-16 text-cream lg:py-24" data-id="element-135" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-2 lg:gap-16" data-id="element-136" data-mp="26xmu97vn7yh6">
        <div data-id="element-137" data-mp="2bwh95yqhp2w0">
          <h2 id="dolor" className="font-display text-3xl font-black leading-tight sm:text-5xl" data-id="element-138" data-mp="2bw7sj1rc482z">
            ¿Cuánto dinero más vas a perder así?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-cream/75" data-id="element-139" data-mp="21z32urya5uhf">
            Quieres emprender en repostería. Pero pierdes ingredientes en pruebas fallidas, compras
            sin calcular costos y vendes sin saber si ganas dinero.
          </p>
          <p className="mt-8 border-l-4 border-gold pl-5 font-display text-2xl font-extrabold leading-snug" data-id="element-140" data-mp="1sywwdq101urr">
            No es falta de ganas.
            <br data-id="element-141" data-mp="3ncfnoi4fsh4m" />
            <span className="text-gold" data-id="element-142" data-mp="3ncxvmc0gojsd">Es falta de un sistema.</span>
          </p>
        </div>

        <ul className="divide-y divide-ink-line border-y border-ink-line" data-id="element-143" data-mp="1yzvirhfuantx">
          {painPoints.map(p => <li key={p.title} className="flex gap-4 py-5" data-id="element-144" data-mp="1u0iyn4gcruv1">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-danger/20" data-id="element-145" data-mp="27sz0i1xipmud">
                <XIcon className="h-4 w-4 text-[#F97066]" aria-hidden="true" data-id="element-146" data-mp="23qvg2nsvf7wy" />
              </span>
              <div data-id="element-147" data-mp="1g1audx5c1wjz">
                <p className="font-display text-lg font-bold" data-id="element-148" data-mp="1g2udrwmacnpz">{p.title}</p>
                <p className="text-cream/60" data-id="element-149" data-mp="1b399r7s9dp6e">{p.detail}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}